module.exports = __webpack_public_path__ + "static/media/window-frame.98bcd412.svg";